import { IResponsiveGenerateSrc } from '@irohalab/deneb-ui';
import { Injectable } from '@angular/core';

@Injectable()
export class ImageKitSrcGeneratorService implements IResponsiveGenerateSrc {

  makeRespSrc(src: string, width: number, height: number, originalWidth: number, originalHeight: number, ratio: number): string {
    if (width !== 0) {
      width = Math.round(width / 20) * 20;
      if (height !== 0) {
        height = width * ratio;
      }
    } else if (height !== 0) {
      height = Math.round(height / 20) * 20;
      if (width !== 0) {
        width = height / ratio;
      }
    }
    if (width === 0) {
      return `${src}?tr=h-${height}`;
    } else if (height === 0) {
      return `${src}?tr=w-${width}`;
    } else {
      return `${src}?tr=w-${width},h-${height}`;
    }
  }

}
